module.exports = {

}


// WEBPACK FOOTER //
// ./src/config/client.local.js